import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Contract } from 'services/action';

import { Page } from 'ui/components';
import _ from 'underscore';
import { MapTrucking } from '../list/component/section';
import {
  Action,
  DetailContract,
  DetailManifest,
  DetailSender,
} from './component/section';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);

  const [data, setData] = React.useState(null);
  const [legs, setLegs] = React.useState(null);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Contract.$show(id));

    if (req?.message === 'success') {
      convertToLegs(req?.data);
    }
  };

  const convertToLegs = async (data) => {
    let chain = [];
    let legs = [];
    data?.shipments?.forEach((el, i) => {
      if (el?.type === 'pickup' || el?.type === 'drop_point') {
        const oexist = _.findWhere(legs, {
          location_id: el?.origin?.id,
        });

        if (!oexist) {
          legs.push({
            delivery_order: {
              ...el,
              document_status: el?.status,
            },
            location_id: el?.origin?.id,
            type: 'pickup',
            location: el?.origin,
          });
        }

        const dexist = _.findWhere(legs, {
          location_id: el?.destination?.id,
        });

        if (!dexist) {
          legs.push({
            delivery_order: {
              ...el,
              document_status: el?.status,
            },
            type: 'drop_point',
            location_id: el?.destination?.id,
            location: el?.destination,
          });
        }
      } else {
        chain.push({
          delivery_order: {
            ...el,
            document_status: el?.status,
          },
          type: 'pickup',
          location_id: el?.origin?.id,
          location: el?.origin,
        });

        chain.push({
          delivery_order: {
            ...el,
            document_status: el?.status,
          },
          type: 'drop_point',
          location_id: el?.destination?.id,
          location: el?.destination,
        });
      }
    });

    const x = _.sortBy(legs, (xx, i) => {
      return legs[i + 1]?.type > xx?.type;
    });

    legs = [...x, ...chain];

    setLegs(legs);

    setData(data);
  };

  const $getPrivilege = async () => {
    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    setPrivilege(pricing);
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  return (
    <Page className="col-lg-10 col-md-10 bordered">
      <Page.Header
        pretitle="Kontrak"
        title={data?.code}
        status={data?.document_status}
        backTo="/order/contract"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding">
        <div className="row m-0">
          <div className={`${data?.auto_manifest ? 'col-md-4' : 'col-md-6'}`}>
            <DetailContract
              data={data}
              privilege={!Session?.privileges || privilege?.pricing}
            />
          </div>

          <div className={`${data?.auto_manifest ? 'col-md-4' : 'col-md-6'}`}>
            <DetailSender data={data} />
          </div>

          {data?.auto_manifest && (
            <div className="col-md-4">
              <DetailManifest data={data} />
            </div>
          )}

          <MapTrucking data={legs} />
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
